// src/scripts/pages/specialties/specialties.js

import initSpecialtyPage from '../../components/specialty-page-init.js';

// Side-effect import used on these pages today
import '../../components/event-modal-init.js';

initSpecialtyPage();
